// // import { useState } from 'react';
// // import { useNavigate, Link } from 'react-router-dom';
// // import axios from 'axios';
// // import { Button } from '../components/ui/button';
// // import { Input } from '../components/ui/input';
// // import { Label } from '../components/ui/label';
// // import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
// // import { toast } from 'sonner';
// // import { API } from '../App';

// // export default function Login() {
// //   const [email, setEmail] = useState('');
// //   const [password, setPassword] = useState('');
// //   const [loading, setLoading] = useState(false);
// //   const navigate = useNavigate();

// //   const handleLogin = async (e) => {
// //     e.preventDefault();
// //     setLoading(true);

// //     try {
// //       const response = await axios.post(`${API}/auth/login`, { email, password });
// //       localStorage.setItem('user', JSON.stringify(response.data));
// //       toast.success('Login successful!');
// //       navigate('/dashboard');
// //       window.location.reload();
// //     } catch (error) {
// //       toast.error(error.response?.data?.detail || 'Login failed');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50 p-4">
// //       <Card className="w-full max-w-md shadow-xl" data-testid="login-card">
// //         <CardHeader className="space-y-2 text-center">
// //           <CardTitle className="text-3xl font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
// //             Ticket Management
// //           </CardTitle>
// //           <CardDescription>Sign in to your account</CardDescription>
// //         </CardHeader>
// //         <CardContent>
// //           <form onSubmit={handleLogin} className="space-y-4">
// //             <div className="space-y-2">
// //               <Label htmlFor="email">Email</Label>
// //               <Input
// //                 id="email"
// //                 type="email"
// //                 placeholder="you@example.com"
// //                 value={email}
// //                 onChange={(e) => setEmail(e.target.value)}
// //                 required
// //                 data-testid="login-email-input"
// //               />
// //             </div>
// //             <div className="space-y-2">
// //               <Label htmlFor="password">Password</Label>
// //               <Input
// //                 id="password"
// //                 type="password"
// //                 placeholder="••••••••"
// //                 value={password}
// //                 onChange={(e) => setPassword(e.target.value)}
// //                 required
// //                 data-testid="login-password-input"
// //               />
// //             </div>
// //             <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit-btn">
// //               {loading ? 'Signing in...' : 'Sign In'}
// //             </Button>
// //           </form>
// //           <div className="mt-4 text-center text-sm">
// //             Don't have an account?{' '}
// //             <Link to="/register" className="text-blue-600 hover:underline" data-testid="register-link">
// //               Register here
// //             </Link>
// //           </div>
// //         </CardContent>
// //       </Card>
// //     </div>
// //   );
// // }
// import { useState } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import { Button } from '../components/ui/button';
// import { Input } from '../components/ui/input';
// import { Label } from '../components/ui/label';
// import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
// import { toast } from 'sonner';

// import { signInWithEmailAndPassword } from "firebase/auth";
// import { doc, getDoc } from "firebase/firestore";
// import { auth, db } from "@/firebase";  // <-- make sure you created firebase.js

// export default function Login() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       // 1. Firebase login
//       const userCred = await signInWithEmailAndPassword(auth, email, password);

//       // 2. Fetch Firestore user profile (role, name, etc.)
//       const userRef = doc(db, "users", userCred.user.uid);
//       const userSnap = await getDoc(userRef);

//       if (!userSnap.exists()) {
//         toast.error("User profile not found!");
//         return;
//       }

//       const userData = {
//         uid: userCred.user.uid,
//         email: userCred.user.email,
//         ...userSnap.data(),
//       };
//       if (!userData.verify) {
//         // Logout immediately
//         await auth.signOut();
//         toast.error("Your account is under verification. Contact admin.");
//         return;
//       }
//       if (userData.suspended) {
//         // Logout immediately
//         await auth.signOut();
//         toast.error("Your account has been suspended. Contact admin.");
//         return;
//       }
//       // 3. Store in localStorage (optional, your app uses it)
//       localStorage.setItem("user", JSON.stringify(userData));
//       await createAuthLog({
//         action: "login",
//         user,
//         message: "User logged in successfully",
//       });
//       toast.success("Login successful!");
//       navigate("/dashboard");
//       window.location.reload();

//     } catch (error) {
//       console.error(error);
//       await createAuthLog({
//         action: "failed_login",
//         email,
//         message: error.message,
//       });
//       toast.error(error.message || "Login failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50 p-4">
//       <Card className="w-full max-w-md shadow-xl" data-testid="login-card">
//         <CardHeader className="space-y-2 text-center">
//           <CardTitle className="text-3xl font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
//             Ticket Management
//           </CardTitle>
//           <CardDescription>Sign in to your account</CardDescription>
//         </CardHeader>
//         <CardContent>
//           <form onSubmit={handleLogin} className="space-y-4">
//             <div className="space-y-2">
//               <Label htmlFor="email">Email</Label>
//               <Input
//                 id="email"
//                 type="email"
//                 placeholder="you@example.com"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//                 data-testid="login-email-input"
//               />
//             </div>
//             <div className="space-y-2">
//               <Label htmlFor="password">Password</Label>
//               <Input
//                 id="password"
//                 type="password"
//                 placeholder="••••••••"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//                 data-testid="login-password-input"
//               />
//             </div>
//             <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit-btn">
//               {loading ? 'Signing in...' : 'Sign In'}
//             </Button>
//           </form>

//         </CardContent>
//       </Card>
//     </div>
//   );
// }
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import { toast } from "sonner";
import LightRays from '../components/LightRays';
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "@/firebase";

import { getDeviceInfo } from "@/utils/deviceinfo";
import { createAuthLog } from "@/utils/createAuthLog";
import Clarity from "@microsoft/clarity";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 🔹 Get public IP
  const getIP = async () => {
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      return data.ip;
    } catch {
      return "N/A";
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    const deviceInfo = getDeviceInfo();
    const ip = await getIP();

    try {
      // 1️⃣ Firebase Auth login
      localStorage.setItem("loginTime", Date.now());

      const userCred = await signInWithEmailAndPassword(auth, email, password);

      // 2️⃣ Load Firestore user profile
      const userRef = doc(db, "users", userCred.user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        await auth.signOut();
        toast.error("User profile not found");
        return;
      }

      const userData = {
        uid: userCred.user.uid,
        email: userCred.user.email,
        ...userSnap.data(),
      };
      // 3️⃣ Account checks
      if (!userData.verify) {
        await auth.signOut();
        toast.error("Account under verification");
        return;
      }

      if (userData.suspended) {
        await auth.signOut();
        toast.error("Account suspended");
        return;
      }

      // 4️⃣ Save user locally
      localStorage.setItem("user", JSON.stringify(userData));

      // 5️⃣ Auth success log
      await createAuthLog({
        action: "login",
        user_id: userData.uid,
        email: userData.email,
        message: "User logged in successfully",
        ip,
        browser: deviceInfo.browser,
        os: deviceInfo.os,
        device: deviceInfo.device,
        user_agent: deviceInfo.userAgent,
      });

      toast.success("Login successful");
      navigate("/dashboard"); // ✅ NO reload

    } catch (error) {
      console.error(error);

      // ❌ Failed login log
      await createAuthLog({
        action: "failed_login",
        email,
        message: error.message || "Invalid credentials",
        ip,
        browser: deviceInfo.browser,
        os: deviceInfo.os,
        device: deviceInfo.device,
        user_agent: deviceInfo.userAgent,
      });

      toast.error("Login failed");
    } finally {
      setLoading(false);
    }
  };

return (
  <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">

    {/* LEFT — WHITE LOGIN */}
    <div className="flex items-center justify-center bg-white px-6">
      <div className="w-full max-w-sm">

        <div className="mb-6">
          <h2 className="text-xl font-medium text-neutral-900">
            Sign in
          </h2>
          <p className="text-sm text-neutral-500">
            Use your company credentials
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">

          <div className="space-y-1">
            <Label className="text-xs text-neutral-600">
              Email
            </Label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="h-9 border-neutral-300 focus:border-neutral-500"
            />
          </div>

          <div className="space-y-1">
            <Label className="text-xs text-neutral-600">
              Password
            </Label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="h-9 border-neutral-300 focus:border-neutral-500"
            />
          </div>

          <Button
            disabled={loading}
            className="w-full h-9 bg-neutral-900 text-white hover:bg-neutral-800"
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>

        </form>

        <div className="mt-6 text-xs text-neutral-400">
          © {new Date().getFullYear()} Hyperhex Technology
        </div>
      </div>
    </div>

    {/* RIGHT — BLACK CONTEXT */}
<div className="hidden lg:flex relative flex-col justify-center bg-black text-white px-20 overflow-hidden">

<div style={{ width: '100%', height: '100%', position: 'absolute' }}>
  <LightRays
    raysOrigin="top-center"
    raysColor="#ffffffff"
    raysSpeed={1.5}
    lightSpread={0.8}
    rayLength={1.2}
    followMouse={true}
    mouseInfluence={0.1}
    noiseAmount={0.1}
    distortion={0.05}
    className="custom-rays"
  />
</div>
  <h1 className="text-3xl font-semibold mb-2">
    Ticket Management System
  </h1>

  <h2 className="text-xl font-medium text-neutral-400 mb-6">
    Internal Operations & Project Tracking
  </h2>

  <p className="text-sm text-neutral-300 leading-relaxed max-w-md mb-8">
    This system is used internally to manage work tickets related to projects,
    operations, and support. All tickets are tracked from creation to resolution.
  </p>

  {/* FEATURE BOXES */}
  <div className="grid grid-cols-2 gap-4 max-w-md">

    <div className="border border-neutral-700 rounded-md px-4 py-3 text-sm text-neutral-200">
      Create & manage tickets
    </div>

    <div className="border border-neutral-700 rounded-md px-4 py-3 text-sm text-neutral-200">
      Assign teams & engineers
    </div>

    <div className="border border-neutral-700 rounded-md px-4 py-3 text-sm text-neutral-200">
      Track status & timelines
    </div>

    <div className="border border-neutral-700 rounded-md px-4 py-3 text-sm text-neutral-200">
      View activity & audit logs
    </div>

  </div>

  <div className="mt-12 text-xs text-neutral-300">
    Authorized internal use only.
  </div>

</div>


  </div>
);




}
